// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_Uz5","cls2":"CoauthorConfirmationCard-cls2_FG0 CoauthorConfirmationCard-cls1_Uz5"};